import { render, staticRenderFns } from "./NewEditChannel.vue?vue&type=template&id=0e2baa56&scoped=true"
import script from "./NewEditChannel.vue?vue&type=script&lang=js"
export * from "./NewEditChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2baa56",
  null
  
)

export default component.exports